import PropTypes from 'prop-types';

const translationPropType = PropTypes.objectOf(
    PropTypes.oneOfType(
        [
            PropTypes.string,
            PropTypes.objectOf(PropTypes.string),
        ],
    ),
);

export default translationPropType;
